<div class="row">
    <div class="col-md-auto icon-column">
        <app-camp-icon [iconName]="item.campIconName"></app-camp-icon>
    </div>
    <div class="col">
        <div class="d-flex w-100 justify-content-between">
            <h6 class="mb-1 main-blue bolded" hznTestId="purchase-row-header">
                {{ item.buyer }} [{{ item.number }}]
            </h6>
            <small class="text-muted" hznTestId="purchase-row-date">{{ item.date | bcDate }}</small>
        </div>
        <p class="mb-1 bolded" hznTestId="purchase-row-amount">
            {{ item.totalAmount | amount }}
            <span
                hznTestId="purchase-row-status"
                class="ml-1"
                [ngClass]="{
                    'status-finalized': isFinalized,
                    'status-refunded': isRefunded,
                }"
                >{{ status }}
                @if (item.isModification) {
                    <span class="main-red ml-1">{{
                        "PurchaseDetails.partiallyRefunded" | translate
                    }}</span>
                }
            </span>
        </p>
        <small class="text-muted">
            <span class="bolded">{{
                "PurchaseList.CampTypeLabel" | translate
            }}</span>
            <span hznTestId="purchase-row-camp-type">{{ campTypeLabel }}</span>
            @if (hasEnrolledChildren) {
                <span
                    >,
                    <span class="bolded">{{
                        "PurchaseList.EnrolledChildren" | translate
                    }}</span>
                    <span> {{ getEnrolledChildren(item) }}</span>
                </span>
            }
        </small>
    </div>
</div>
